module.exports = __webpack_public_path__ + "img/PlatformComposition_App.a6a6dc95.png";